
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/networking",
      function () {
        return require("private-next-pages/security/networking.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/networking"])
      });
    }
  